<template>
	<v-container fluid id="consultas-container" class="d-flex flex-column">
		<!-- Debug element to check mobile breakpoint -->
		
		<v-btn-toggle style="width: 100%;" v-if="!$vuetify.breakpoint.mobile">
			<GlobalNewButton class="mr-2"/>
			<v-btn class="custom-button-consultas" :class="this.$store.entregaStore.state.selectedType === 2 ? 'selected':''" tile
				:disabled="!checkPermissions(['view_entregas'])"
				@click="changeListing(2)">
				<div class="d-flex align-start">
					<v-icon>mdi-view-list-outline</v-icon>
					<div class="ml-2">
						<p class="mb-0 font-weight-bold text-capitalize">Pendientes</p>
						<p class="mb-0 text-capitalize" style="font-size: 10px;opacity: 0.6;">Entrega</p>
					</div>
				</div>
			</v-btn>
			<v-btn class="custom-button-consultas" :class="this.$store.entregaStore.state.selectedType === 3 ? 'selected':''" tile
				:disabled="!checkPermissions(['view_entregas'])"
				@click="changeListing(3)">
				<div class="d-flex align-start">
					<v-icon>mdi-text-box-check-outline</v-icon>
					<div class="ml-2">
						<p class="mb-0 font-weight-bold text-capitalize">Finalizadas</p>
						<p class="mb-0 text-capitalize" style="font-size: 10px;opacity: 0.6;">Entrega</p>
					</div>
				</div>
			</v-btn>
			<v-btn class="custom-button-consultas" :class="this.$store.entregaStore.state.selectedType === 4 ? 'selected':''" tile
				:disabled="!checkPermissions(['view_entregas'])"
				@click="changeListing(4)">
				<div class="d-flex align-start">
					<v-icon>mdi-chart-areaspline</v-icon>
					<div class="ml-2">
						<p class="mb-0 font-weight-bold text-capitalize">Gráficos</p>
						<p class="mb-0 text-capitalize" style="font-size: 10px;opacity: 0.6;">Entrega</p>
					</div>
				</div>
			</v-btn>
			<v-btn class="custom-button-consultas" :class="this.$store.entregaStore.state.selectedType === 5 ? 'selected':''" tile
				:disabled="!checkPermissions(['view_entregas'])"
				@click="changeListing(5)">
				<div class="d-flex align-start">
					<v-icon>mdi-database</v-icon>
					<div class="ml-2">
						<p class="mb-0 font-weight-bold text-capitalize">Protocolos</p>
						<p class="mb-0 text-capitalize" style="font-size: 10px;opacity: 0.6;">Entrega</p>
					</div>
				</div>
			</v-btn>
			<v-btn class="custom-button-consultas" :class="this.$store.entregaStore.state.selectedType === 6 ? 'selected':''" tile
				:disabled="!checkPermissions(['view_entregas'])"
				@click="changeListing(6)">
				<div class="d-flex align-start">
					<v-icon>mdi-map</v-icon>
					<div class="ml-2">
						<p class="mb-0 font-weight-bold text-capitalize">Planos</p>
						<p class="mb-0 text-capitalize" style="font-size: 10px;opacity: 0.6;">Entrega</p>
					</div>
				</div>
			</v-btn>
			<v-btn class="custom-button-consultas" :class="this.$store.entregaStore.state.selectedType === 7 ? 'selected':''" tile
				:disabled="!checkPermissions(['view_entregas'])"
				@click="changeListing(7)">
				<div class="d-flex align-start">
					<v-icon>mdi-file-document-edit-outline</v-icon>
					<div class="ml-2">
						<p class="mb-0 font-weight-bold text-capitalize">Borradores</p>
						<p class="mb-0 text-capitalize" style="font-size: 10px;opacity: 0.6;">Entrega</p>
					</div>
				</div>
			</v-btn>
		</v-btn-toggle>
    <v-menu offset-y v-else>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
					rounded
					color="#2D4B95"
					dark
					small
					block
          v-bind="attrs"
          v-on="on"
        >
          Seleccione Acción
        </v-btn>
      </template>
			<div class="d-flex flex-column pa-2 white" style="gap: 5px;">
				<GlobalNewButton :fullWidth="true"/>
				<v-divider class="my-1"></v-divider>
				<v-btn class="custom-button-consultas" :class="this.$store.entregaStore.state.selectedType === 2 ? 'selected':''" tile
					@click="changeListing(2)">
					<div class="d-flex align-start">
						<v-icon>mdi-view-list-outline</v-icon>
						<div class="ml-2">
							<p class="mb-0 font-weight-bold text-capitalize">Pendientes</p>
							<p class="mb-0 text-capitalize" style="font-size: 10px;opacity: 0.6;">Entregas</p>
						</div>
					</div>
				</v-btn>
				<v-btn class="custom-button-consultas" :class="this.$store.entregaStore.state.selectedType === 3 ? 'selected':''" tile
					@click="changeListing(3)">
					<div class="d-flex align-start">
						<v-icon>mdi-text-box-check-outline</v-icon>
						<div class="ml-2">
							<p class="mb-0 font-weight-bold text-capitalize">Finalizadas</p>
							<p class="mb-0 text-capitalize" style="font-size: 10px;opacity: 0.6;">Entregas</p>
						</div>
					</div>
				</v-btn>
				<v-btn class="custom-button-consultas" :class="this.$store.entregaStore.state.selectedType === 4 ? 'selected':''" tile
					@click="changeListing(4)">
					<div class="d-flex align-start">
						<v-icon>mdi-chart-areaspline</v-icon>
						<div class="ml-2">
							<p class="mb-0 font-weight-bold text-capitalize">Gráficos</p>
							<p class="mb-0 text-capitalize" style="font-size: 10px;opacity: 0.6;">Entregas</p>
						</div>
					</div>
				</v-btn>
				<v-btn class="custom-button-consultas" :class="this.$store.entregaStore.state.selectedType === 5 ? 'selected':''" tile
					@click="changeListing(5)">
					<div class="d-flex align-start">
						<v-icon>mdi-database</v-icon>
						<div class="ml-2">
							<p class="mb-0 font-weight-bold text-capitalize">Protocolos</p>
							<p class="mb-0 text-capitalize" style="font-size: 10px;opacity: 0.6;">Entregas</p>
						</div>
					</div>
				</v-btn>
				<v-btn class="custom-button-consultas" :class="this.$store.entregaStore.state.selectedType === 6 ? 'selected':''" tile
					@click="changeListing(6)">
					<div class="d-flex align-start">
						<v-icon>mdi-map-legend</v-icon>
						<div class="ml-2">
							<p class="mb-0 font-weight-bold text-capitalize">Planos</p>
							<p class="mb-0 text-capitalize" style="font-size: 10px;opacity: 0.6;">Entregas</p>
						</div>
					</div>
				</v-btn>
				<v-btn class="custom-button-consultas" :class="this.$store.entregaStore.state.selectedType === 7 ? 'selected':''" tile
					:disabled="!checkPermissions(['view_entregas'])"
					@click="changeListing(7)">
					<div class="d-flex align-start">
						<v-icon>mdi-file-document-edit-outline</v-icon>
						<div class="ml-2">
							<p class="mb-0 font-weight-bold text-capitalize">Borradores</p>
							<p class="mb-0 text-capitalize" style="font-size: 10px;opacity: 0.6;">Entregas</p>
						</div>
					</div>
				</v-btn>
			</div>
    </v-menu>
		<div v-if="checkPermissions(['view_entregas'])">
			<!-- Desktop version -->
			<ListadoEntregas ref="ListadoEntregasDesktop"
				v-if="(this.$store.entregaStore.state.selectedType === 2 || this.$store.entregaStore.state.selectedType === 3)"
				:ended="this.$store.entregaStore.state.selectedType === 3"/>
			<EntregasGraphs v-if="this.$store.entregaStore.state.selectedType === 4" />
			<Protocolos v-if="this.$store.entregaStore.state.selectedType === 5" />
			<Planos v-if="this.$store.entregaStore.state.selectedType === 6" />
			<ListadoBorradores
				v-if="this.$store.entregaStore.state.selectedType === 7"
				:draftType="9"
				@loadDraft="loadDraft"
			/>
		</div>
		<div v-else class="d-flex flex-column align-center justify-center" style="height: 100%;min-height: 300px;">
			<v-icon size="50" color="grey lighten-1">mdi-lock</v-icon>
			<p class="text-center mt-2 mb-0 text--grey">No tienes permisos para ver las Entregas.</p>
			<p class="text-center caption text--grey">Contacta con el administrador del proyecto.</p>
		</div>
	</v-container>
</template>

<script>
import ListadoEntregas from './ListadoEntregas'
import EntregasGraphs from './EntregasGraphs'
import Protocolos from './Protocolos'
import Planos from './Planos'
import GlobalNewButton from '@/components/Globals/Helpers/GlobalNewButton'
import ListadoBorradores from '@/components/Globals/Helpers/ListadoBorradores'
import { getEntregaByID, getConfig } from "@/helpers/api/entrega";
import { getJobTypes } from "@/helpers/api/user";

export default {
	name: 'EntregaContainer',
	components: {ListadoEntregas, EntregasGraphs, Protocolos, Planos, GlobalNewButton, ListadoBorradores},
	computed: {
		selectedProject(){
			return this.$store.projectsStore.state.selectedProject
		}
	},
	watch: {
		selectedProject(newVal, oldVal){
			if(!newVal?.id || newVal.id === oldVal?.id) return
			const selectedType = this.$store.entregaStore.state.selectedType
			if(selectedType === 4) this.getEntregaGraphsData()
			else if(selectedType === 5) this.getProtocolos()
			else if(selectedType === 6) this.getPlanos()
			else if(selectedType === 2 || selectedType === 3) this.getEntregaList()
		}
	},
	data: () => ({
		createTareaModal: false,
	}),
	mounted(){
		// if(!this.checkPermissions(['view_Entrega'])){
		// 	this.$store.entregaStore.commit('setSelectedType', 0)
		// }
	},
	methods: {
		loadDraft(draft){
			const draftType = draft.raw_type
			if(draftType === 9){
				this.$store.entregaStore.commit('setDraftToLoad', draft)
				this.$store.entregaStore.commit('setCreateEntregaModal', true)
			}
			else if(draftType === 11 || draftType === 12){
				console.log('Loading draft for Entrega Approval:', draft)
				this.$store.entregaStore.commit('setDraftToLoad', draft)
				this.viewEntrega(draft.data?.entregaId, false)
			}
		},
		changeListing(selected){
      if(this.$store.entregaStore.state.selectedType != selected){
        this.$store.entregaStore.commit('setSelectedType', selected)
        if(selected == 4){
          this.getEntregaGraphsData()
        } else if(selected == 6){
          this.getPlanos()
        } else if(selected == 5){
          this.getProtocolos()
        }
        
      }
    },
    getEntregaGraphsData(){
      let project_id = null
      if(this.$store.projectsStore.state.selectedProject){
        project_id = this.$store.projectsStore.state.selectedProject.id
      }
      else{
        const id = localStorage.getItem('selectedProjectID')
        project_id = parseInt(id)
      }
      if(project_id){
        this.$store.entregaStore.dispatch('getEntregaGraphsData', {project_id})
      }
    },
		getPlanos(){
			let project_id = null
			if(this.$store.projectsStore.state.selectedProject){
				project_id = this.$store.projectsStore.state.selectedProject.id
			}
			else{
				const id = localStorage.getItem('selectedProjectID')
				project_id = parseInt(id)
			}
			if(project_id){
				this.$store.entregaStore.dispatch('getPlanos', {project_id})
			}
		},
		getProtocolos(){
			let project_id = null
			if(this.$store.projectsStore.state.selectedProject){
				project_id = this.$store.projectsStore.state.selectedProject.id
			}
			else{
				const id = localStorage.getItem('selectedProjectID')
				project_id = parseInt(id)
			}
			if(project_id){
				this.$store.entregaStore.dispatch('getProtocolos', {project_id})
			}
		},
		async getEntregaList(){
			// if(this.checkPermissions(['view_Entrega'])){
				let project_id = null
				if(this.$store.projectsStore.state.selectedProject){
					project_id = this.$store.projectsStore.state.selectedProject.id
				}
				else{
					const id = localStorage.getItem('selectedProjectID')
					project_id = parseInt(id)
				}
				if(project_id){
					this.$store.entregaStore.dispatch('getEntrega', {project_id})
				}
			// }
		},
    async viewEntrega(entregaId, seenByMe) {
      if (!this.selectedProject) return;
      const projectID = this.selectedProject.id;
      this.$store.entregaStore.commit("setCurrentEntrega", { loading: true });
      try {
        const entregaResponse = await getEntregaByID({ entrega_id: entregaId });
        const [configResponse, jobTypesResponse] = await Promise.all([
          getConfig({ project_id: projectID }),
          getJobTypes({ project_id: projectID }),
        ]);
        this.$store.usersStore.commit("setJobTypes", jobTypesResponse.job_types);
        this.$store.entregaStore.commit("setConfig", configResponse.config);
				if (entregaResponse.code === 403) {
					this.$store.entregaStore.commit("setCurrentEntrega", null);
				} else if (entregaResponse.code === 200) {
          const entregaData = entregaResponse.entrega;
          entregaData.prev_seen_by_me = seenByMe;
          this.$store.entregaStore.commit("setCurrentEntrega", entregaData);
          // this.setStatusDescription(entregaData);
        }
      } catch (error) {
        console.error("Error loading entrega details:", error);
        this.$store.entregaStore.commit("setCurrentEntrega", { loading: false, error: true });
      }
    },
	}
};
</script>

<style scoped>
	.text-primary{color: #2D4B95;}
	.custom-button-consultas.v-btn{
		background-color: white;
		color: #2D4B95;
		opacity: 1!important;
		text-align: left;
	}
	/deep/ .custom-button-consultas.v-btn .v-icon,
	/deep/ .custom-button-consultas.v-btn p{
		color: #2D4B95!important;
		font-size: 13px;
	}
	/deep/ .custom-button-consultas.v-btn .v-icon{font-size: 20px;}
	/deep/ .custom-button-consultas.v-btn:hover .v-icon,
	/deep/ .custom-button-consultas.v-btn:hover p,
	/deep/ .custom-button-consultas.v-btn.selected .v-icon,
	/deep/ .custom-button-consultas.v-btn.selected p{
		color: white!important;;
	}
	.custom-button-consultas.selected,
	.custom-button-consultas:hover{
		background-color: #2D4B95!important
	}

</style>